import React from 'react';
import ReactDOM from 'react-dom/client';
import  Quiz from './quizApp/quiz2';
//? I got stuck with the error, react-scripts is not found as internal or external command, so what i did, to 
//? solve this, i ran the command  !_____npm install react-scripts --save____!
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Quiz/>);












































